export default "__VITE_ASSET__B038B03J__"